import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

interface FieldProps {
  label: string;
  htmlFor: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}

/** Label + control + optional hint, wired up for screen readers. */
export function Field({ label, htmlFor, hint, className, children }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-muted">
        {label}
      </label>
      {children}
      {hint ? <p className="text-xs text-muted">{hint}</p> : null}
    </div>
  );
}
